import React from "react";
import styles from "./beneficiary.module.css";
import { SuccessVideo } from "../../public/images/icon";
import {
  maskAccountNo,
  formatAmountWithDecimal,
} from "../../../src/Constants/helper";
import { getTransferDetails } from "../../../src/utils/utils";

const TransferStep3 = ({
  transferId,
  amount,
  remarks,
  lienAccountNo,
  unlienAccountNo,
  name,
  transferMethod = "Borderless Instant",
  transferFee = "Free",
  transferPurpose = "Lien Release",
  transferOn,
  extraDetails = [],
  successIcon = null,
  transferType = "UNLIEN",
}) => {
  const baseDetails = getTransferDetails({
    name,
    transferMethod,
    remarks,
    transferOn,
    transferFee,
    transferPurpose,
    extraDetails,
    transferType,
  });

  return (
    <div className={styles.lienTransferForm}>
      <div className={styles.formScrollArea}>
        <div className={styles.successSection}>
          {successIcon || (
            <img
              src={SuccessVideo}
              alt="success"
              width={45}
              height={45}
              style={{ borderRadius: "50%" }}
            />
          )}
          <div className={styles.successTitle}>
            {transferType === "EMI"
              ? "Your EMI Deduction is Successful"
              : "Your payment is Successful"}
          </div>
          {transferId && (
            <div className={styles.transferIdText}>
              Transfer ID : {transferId}
            </div>
          )}
        </div>

        <div className={styles.amountBox}>
          <div className={styles.amountLabel}>
            {transferType === "EMI"
              ? "Deducted amount:"
              : "Transferred amount:"}
          </div>
          <div className={styles.amountValue}>
            {formatAmountWithDecimal(amount)}
          </div>
        </div>
        {transferType !== "EMI" && (
          <div className={styles.accountTransferRow}>
            <div className={styles.accountBox}>
              <div className={styles.accountLabel}>Lien account no:</div>
              <div className={styles.accountNo}>
                {maskAccountNo(lienAccountNo)}
              </div>
            </div>
            <div className={styles.arrowIcon}>→</div>
            <div className={styles.accountBox}>
              <div className={styles.accountLabel}>Unlien account no:</div>
              <div className={styles.accountNo}>
                {maskAccountNo(unlienAccountNo)}
              </div>
            </div>
          </div>
        )}
        <div className={styles.detailsTable}>
          {baseDetails.map((item, idx) => (
            <div key={idx} className={styles.detailRow}>
              <div className={styles.detailLabel}>{item.label}</div>
              <div
                className={`${styles.detailValue} ${
                  item.isGreen ? styles.greenText : ""
                }`}
              >
                {item.value || "—"}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TransferStep3;